<template>
  <div>
    <div class="flex justify-end">
      <router-link v-if="allTracks.length > 0 && !isMyFavorites"
                   class="mr3 no-underline"
                   :title="$t('tracks.seeAll')"
                   :to="{name:'tracksList'}">
        <span class="mr3">{{ $t('tracks.seeAll') }}</span>
      </router-link>
      <!--<p v-if="playlists.length > 0" class="mr5">{{ $t('playlists.seeAll') }}</p>-->
      <!--<p v-if="recommendedPlaylists.length > 0" class="mr5">{{ $t('playlists.seeAll') }}</p>-->
      <router-link v-if="artists.length > 0 && !isMyFavorites"
                   class="mr3 no-underline"
                   :title="$t('artists.seeAll')"
                   :to="{name:'new-artists-list'}">
        <span class="mr3">{{ $t('artists.seeAll') }}</span>
      </router-link>
      <router-link v-if="playlists.length > 0 && !isMyFavorites"
                   class="mr3 no-underline"
                   :title="$t('playlists.seeAll')"
                   :to="{name:'new-playlists-list'}">
        <span class="mr3">{{ $t('playlists.seeAll') }}</span>
      </router-link>
    </div>
    <!-- start, navegación mediante genero principal y secundario -->
    <div v-show="withFilters && genresMain.length > 0">
      <!-- start, aca agregamos componente para genero principal -->
      <div
        style="background-color: #393839; position: relative; display: flex"
        class="w-100 justify-around items-center ttu"
      >
        <!-- boton de navegacion izquierdo -->
        <div>
          <a
            style="margin-left: 10px; fill: white; cursor: pointer"
            v-on:click="genTranslate('genMain', 'left')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-left"
              viewBox="0 0 16 16"
            >
              <path
                d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"
              />
            </svg>
          </a>
        </div>

        <div></div>

        <div v-if="allTracks.length > 0" class="track-container-scroll container-scroll w-100">
          <div id="genMain" class="container-genbar">
            <div
              v-show="allTracks.length > 0"
              class="genre-filter f6 link ph2 pv2 dim dib white"
              v-for="genre in allTracks"
              :track-by="genre.id"
              :key="genre.id"
              :tabindex="genre.title"
              :class="{
                'genre-filter-selected': genreFilter == genre.id,
                pointer: genreFilter != genre.id,
              }"
              @click="setPlayer(genre, allTracks)"
            >
              <carousel-item
                :isMyFavorites="isMyFavorites"
                :track="genre"
                style="width:190px"
              />
            </div>
          </div>
        </div>
        <div v-if="playlists" class="container-scroll w-100">
          <div id="genMain" class="container-genbar">
            <div
              v-show="playlists.length > 0"
              class="genre-filter f6 link dim ph2 pv2 dim dib white"
              v-for="genre in playlists"
              :track-by="genre.id"
              :key="genre.id"
              :tabindex="genre.title"
              :class="{
                'genre-filter-selected': genreFilter == genre.id,
                pointer: genreFilter != genre.id,
              }"
            >
              <modal-playlist-card
                :playlist="genre"
                style="width:190px"
              />
            </div>
          </div>
        </div>
        <div v-if="recommendedPlaylists" class="container-scroll w-100">
          <div id="genMain" class="container-genbar">
            <div
              v-show="recommendedPlaylists.length > 0"
              class="genre-filter f6 link dim ph2 pv2 dim dib white"
              v-for="genre in recommendedPlaylists"
              :track-by="genre.id"
              :key="genre.id"
              :tabindex="genre.title"
              :class="{
                'genre-filter-selected': genreFilter == genre.id,
                pointer: genreFilter != genre.id,
              }"
            >
              <modal-playlist-card
                :playlist="genre"
                style="width:190px"
              />
            </div>
          </div>
        </div>
        <div v-if="artists" class="container-scroll w-100">
          <div id="genMain" class="container-genbar">
            <div
              v-show="artists.length > 0"
              class="genre-filter f6 link ph2 pv2 dim dib white"
              v-for="artist in artists"
              :key="artist.id"
              :class="{
                'genre-filter-selected': genreFilter == artist.id,
                pointer: genreFilter != artist.id,
              }"
            >
              <artist-card
                :artist="artist"
                :isProfile="isMyFavorites"
                style="width:190px"
              />
            </div>
          </div>
        </div>
        <!-- boton de navegacion derecho -->
        <div>
          <a
            style="margin-right: 10px; fill: white; cursor: pointer"
            v-on:click="genTranslate('genMain', 'right')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-right"
              viewBox="0 0 16 16"
            >
              <path
                d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- end, aca agregamos componente para genero principal -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CarouselItem from './CarouselItem.vue'
import ArtistCard from '../artists/ArtistCard'
import ModalPlaylistCard from '../PlaylistProfile/ModalPlaylistCard.vue'

export default {
  components: {
    CarouselItem,
    ArtistCard,
    ModalPlaylistCard
  },
  name: 'custom-carousel',
  props: {
    withFilters: {
      default: true
    },
    allTracks: {
      default: false
    },
    artists: {
      default: false
    },
    playlists: {
      default: false
    },
    recommendedPlaylists: {
      default: false
    },
    withPagination: {
      default: true
    },
    loading: {
      required: true
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    },
    textToFilter: {
      default: 'null'
    },
    isMyFavorites: {
      default: false
    }
  },
  data () {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genMainTranslatePosition: 0,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: 0,
      filterText: this.textToFilter
    }
  },
  methods: {
    ...mapActions('track', [
      'getGenresMain',
      'setGenreFilter',
      'getAll',
      'loadMore',
      'setFrom'
    ]),
    ...mapActions('player', [
      'setPlaylist',
      'setPlaying',
      'changeTrack'
    ]),
    ...mapActions('artist', [
      'loadMoreArtists'
    ]),
    ...mapActions('playlist', [
      'loadMorePlaylist'
    ]),
    playTrack (track) {
      if (this.currentTrack !== track) {
        this.$emit('play')
        this.changeTrack(track)
      } else {
        this.setPlaying(true)
      }
    },
    resetPositions () {
      this.translatePosition = 0
      this.genMainTranslatePosition = 0
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')'
      this.$el.querySelector('#genMain').style = style
    },
    setPlayer (track, playlist) {
      this.setPlaylist(playlist)
      this.playTrack(track)
    },

    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur (event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      }
      event.target.style.background = '#E6007E'
      event.target.style.color = 'white'
    },
    // emazzu, end, para mantener el color de seleccion en el genero padre

    nextPage () {
      if (this.filterText === '' || this.filterText === null) {
        this.filterText = null
      }
      if (!this.preventLoadMore) {
        this.busy = true
        if (this.artists) {
          this.loadMoreArtists(this.filterText).then(() => {
            this.busy = false
          })
        }
        if (this.allTracks) {
          this.loadMore(this.filterText).then((res) => {
            this.busy = false
          })
        }
        if (this.playlists) {
          this.loadMorePlaylist(this.filterText).then(() => {
            this.busy = false
          })
        }
        if (this.recommendedPlaylists) {
          this.loadMoreRecommendedPlaylist(this.filterText).then(() => {
            this.busy = false
          })
        }
      }
    },

    genTranslate (element, arrow) {
      const transitionValue = 200
      if (!this.busy) {
        if (element === 'genMain') {
          this.genMainTranslatePosition += (arrow === 'left' ? transitionValue : transitionValue * -1)
          this.translatePosition = this.genMainTranslatePosition
        }

        if (this.translatePosition >= transitionValue) {
          this.translatePosition = 0
          this.genMainTranslatePosition = 0
        }

        if (this.translatePosition <= -(transitionValue * (this.allTracks.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * (this.artists.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * (this.playlists.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * (this.recommendedPlaylists.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * this.allTracks.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.allTracks.length - 2))
          this.genMainTranslatePosition = -(transitionValue * (this.allTracks.length - 2))
        }

        if (this.translatePosition <= -(transitionValue * this.artists.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.artists.length - 4))
          this.genMainTranslatePosition = -(transitionValue * (this.artists.length - 4))
        }

        if (this.translatePosition <= -(transitionValue * this.playlists.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.playlists.length - 1))
          this.genMainTranslatePosition = -(transitionValue * (this.playlists.length - 1))
        }

        if (this.translatePosition <= -(transitionValue * this.recommendedPlaylists.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.recommendedPlaylists.length - 1))
          this.genMainTranslatePosition = -(transitionValue * (this.recommendedPlaylists.length - 1))
        }

        var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')'
        this.$el.querySelector('#' + element).style = style
      }
    }
  },
  computed: {
    ...mapGetters('player', ['currentTrack']),
    ...mapGetters('track', [
      'genresMain',
      'genreFilter',
      'noMoreResults'
    ]),
    loadingMore () {
      return this.$loading.isLoading('track loadMore')
    },
    preventLoadMore () {
      return this.loadingMore || this.noMoreResults || this.busy
    },

    loadingGenresMain () {
      return this.$loading.isLoading('track getGenresMain')
    }
  },
  watch: {
    genreFilter () {
      this.resetPositions()
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

.VueCarousel-inner{
  max-width: 20% !important;
}
.track-playing {
    background-color: $primary-color !important;
  }

.track-list {
  max-height: $main-height;
  height: min-content;
}

.genre-filter {
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Standard syntax */
  white-space: nowrap;
}

.genre-filter-selected {
  background-color: $accent-color;
  color: white;
}

@media (min-width: 320px) {
  .item-container :hover {
    background-color: lightgray !important;
  }

  .track-list {
    max-height: $main-height;
    height: min-content;
  }

  .genre-filter {
    -webkit-user-select: none; /* Safari 3.1+ */
    -moz-user-select: none; /* Firefox 2+ */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Standard syntax */
    white-space: nowrap;
  }

  .genre-filter-selected {
    background-color: darkgray;
    color: black;
  }

  @media (min-width: 769px) {
    .item-container :hover {
      background-color: $primary-color;
    }
    .item-container {
      height: 3rem;
    }
  }

  @media (min-width: 1441px) {
    .track-list {
      padding-left: 10rem;
      padding-right: 10rem;
    }
  }

  @media (max-width: 769px) {
    .track-list-header {
      display: none;
    }
    .track-list {
      display: flex;
      flex-wrap: wrap;
    }
    .track-container {
      height: 6rem;
      width: 45%;
      margin: 2.5%;
    }
    .genre-filter {
      padding: 4px;
    }
  }

  @media (max-width: 600px) {
    .track-container {
      width: 95%;
    }
  }

  .container-scroll {
    overflow-x: scroll;
    scroll-behavior: smooth;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .track-container-scroll {
    margin-left: 19px;
  }

  .container-genbar {
    display: flex;
    transition: all 0.3s ease-out;
  }

    // como personalizar el scrolling
    // https://css-tricks.com/custom-scrollbars-in-webkit/
    //
  .container-scroll::-webkit-scrollbar {
    display: none;
    scroll-behavior: smooth;
    height: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/CustomCarousel.vue